import { DiagnosticUser } from "sdk/diagnosticUser";
import { useCurrentDiagnosticUser } from "./useCurrentDiagnosticUser";

/**
 * Hook for use in routes protected by requireDiagnostics={true}.
 * Returns a non-null DiagnosticUser, throwing an error if the user is not authenticated.
 * This enforces the runtime guarantee provided by the Protector component.
 */
export const useRequiredDiagnosticUser = (): DiagnosticUser => {
  const user = useCurrentDiagnosticUser();

  if (!user) {
    throw new Error(
      "DiagnosticUser required but not found. This route must be protected with requireDiagnostics={true}"
    );
  }

  return user;
};
